var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.375V8.725L14.15 4.375H11.32L16.5 9.555V20.375H18.5ZM22.5 20.375V7.065L19.81 4.375H16.98L20.5 7.895V20.375H22.5ZM8.5 4.375L2.5 10.375V20.375H14.5V10.375L8.5 4.375Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.375V8.725L14.15 4.375H11.32L16.5 9.555V20.375H18.5ZM22.5 20.375V7.065L19.81 4.375H16.98L20.5 7.895V20.375H22.5ZM8.5 4.375L2.5 10.375V20.375H14.5V10.375L8.5 4.375Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyInactive);
export default __webpack_public_path__ + "static/media/FamilyInactive.4fdec52bbf99ff525fd3d36db722a141.svg";
export { ForwardRef as ReactComponent };